module.exports = __webpack_public_path__ + "static/media/vision.4bd46d73.svg";